<template>
    <div class="describe-li">
        <div class="p1" v-if="describeItem.title">{{describeItem.title}}</div>
        <div class="p2" v-html="describeItem.content"></div>
        <div class="img-show" v-if="describeItem.images_arr && describeItem.images_arr.length > 0">
            <img
                v-for="imgItem,imgIndex in describeItem.images_arr"
                :preview="moduleId + describeItem.title"
                :src="img_path(img_req_url + imgItem)"
                :key="imgIndex"
            >
        </div>
    </div>
</template>
<script>
export default {
  props: ['describeItem', 'moduleId'],
  computed: {
    img_req_url() {
      return this.$store.state.img_req_url
    }
  },
  methods: {
    img_path(url) {
      let str = url.substring(url.length - 15)
      if(str == 'gif/vcbeat-logo') {
        return url.replace(str, 'gif')
      } else {
        return url
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/common.stylus'
.describe-li
  padding-left: 26px
  position: relative
  &+div
    margin-top: 20px
  .p1
    font-size: 16px
    line-height: 22px
    commonColor(#E9E9EB, #333333)
    font-weight: 600
    margin-bottom: 8px
  .p2
    font-size: 14px
    commonColor(#bcbdc1, #666666)
    line-height: 22px
    margin-bottom: -4px
    >>> p
      padding-left: 8px
      position: relative
  .img-show
    margin-top: 16px
    padding-left: 8px
    img
      display: block
      margin: 0 auto
      max-width: 100% !important
      cursor: pointer
      &+img
        margin-top: 16px
  &:before
    content: ''
    position: absolute
    width: 17px
    height: 14px
    background-image: url('~pic/remark_icon.png')
    background-size: 100% 100%
    top: 3px
    left: 0
</style>
